import { EXPIRING_SOON_DAY_COUNT } from '@@utils/certifications';

import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('usersTable');

    return {
        ACTIONS_LABEL: t('actionsLabel'),
        ACTIVE: t('active'),
        ALL_CERTIFICATION_STATUSES: t('allCertificationStatuses'),
        CERTIFICATION_STATUS_FILTER_LABEL: t('certificationStatusFilterLabel'),
        CERTIFICATIONS: t('certifications'),
        EMAIL: t('email'),
        EMPTY_DESCRIPTION: t('emptyDescription'),
        EMPTY_HEADING: t('emptyHeading'),
        EXPIRED_CERTIFICATIONS: t('expiredCertifications'),
        EXPIRING_CERTIFICATIONS: t('expiringCertifications', {
            dayCount: EXPIRING_SOON_DAY_COUNT
        }),
        INACTIVE: t('inactive'),
        LOAD_ERROR: t('loadError'),
        LOAD_MORE: t('loadMore'),
        MANAGE: t('manage'),
        NAME: t('name'),
        NO_CERTIFICATIONS: t('noCertifications'),
        NO_MATCHES_DESCRIPTION: t('noMatchesDescription'),
        NO_MATCHES_HEADING: t('noMatchesHeading'),
        ROLE: t('role'),
        STATUS: t('status'),
        TABLE_LABEL: t('tableLabel')
    };
};

export default useTranslation;
